export class CompaniesService {
    constructor(axios, apiUrl) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
    }

    async getInvoices(sqldbid, data) {
        return await this.$axios.post(this.apiUrl + `Companies/RGS/Company/SQLDBID/${sqldbid}/Invoices/Ids`, 
            data
        ).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }

    async getInvoice(sqldbid, id) {
        return await this.$axios.get(this.apiUrl + `Companies/RGS/Company/SQLDBID/${sqldbid}/Invoices/Invoice/${id}`).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
    
    async getUpdatedInvoice(sqldbid, id) {
        return await this.$axios.get(this.apiUrl + `Companies/SG/Company/SQLDBID/${sqldbid}/Invoices/Invoice/${id}`, {responseType: "blob"}).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }

    async getServiceYear(sqldbid) {
        return await this.$axios.get(this.apiUrl + `Companies/SG/Franchise/SQLDBID/${sqldbid}/ServiceYear`).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return null;
        });
    }

    async getRemainingMonths(sqldbid) {
        return await this.$axios.get(this.apiUrl + `Companies/SG/Franchise/SQLDBID/${sqldbid}/RemainingMonths`).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return null;
        });
    }

    async getUCMSAdminFAQ(payload) {

        return await this.$axios.post(this.apiUrl + `Companies/UCMS/Company/GetUCMSAdminFAQ`, payload).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
}